import {
  REGANTO_PREMIER_FAILED,
  REGANTO_PREMIER_REQUEST,
  REGANTO_PREMIER_SUCCESS,
} from "app/redux/actions/SeriesProduct/RegantoPremier/constant";

const INIT_STATE = {
  loading: false,
  totalPage: 0,
  data: [],
  error: {
    isError: false,
    message: null,
  },
};

export const regantoPremierReducer = function (state = INIT_STATE, action) {
  switch (action?.type) {
    case REGANTO_PREMIER_REQUEST:
      return {
        loading: true,
        totalPage: 0,
        data: [],
        error: {
          isError: false,
          message: null,
        },
      };
    case REGANTO_PREMIER_SUCCESS:
      return {
        loading: false,
        data: action?.payload?.data,
        totalPage: action?.payload?.totalPage,
        error: {
          isError: false,
          message: null,
        },
      };
    case REGANTO_PREMIER_FAILED:
      const { isError = true, message = "Something Went Wrong" } =
        action?.payload?.error || {};
      return {
        loading: false,
        totalPage: 0,
        data: [],
        error: {
          isError: isError,
          message: message,
        },
      };
    default:
      return state;
  }
};
